/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React, { useEffect, useState } from "react";
import { logout } from "../../auth/utils";
import fetchHelper from "../../services/fetchHelper";
import { USER_AGREEMENTS_ENABLED } from "../../constants/AppConfigConstants";
import { useToasts } from "react-toast-notifications";
import "./main.css";

const ModalAgreements = ({ user }) => {
  const { addToast } = useToasts();
  const [dataAgreement, setDataAgreement] = useState({});

  useEffect(() => {
    (async () => {
      try {
        if (user && localStorage.getItem("showUserAgreements")) {
          const { data: featureFlags } = await fetchHelper.getV2({
            url: "/patientmanagement/rest/user-agreements/feature-flags/all",
          });
          const userAgreementsFlag = featureFlags.find(
            (flag) => flag.featureName === USER_AGREEMENTS_ENABLED
          );

          if (userAgreementsFlag?.enabled) {
            const { data } = await fetchHelper.getV2({
              url: "/patientmanagement/rest/user-agreements/unaccepted",
            });

            if (data.length) {
              setDataAgreement(data[0]);
            } else {
              localStorage.removeItem("showUserAgreements");
            }
          }
        }
      } catch (error) {
        handleErrors(error);
      }
    })();
  }, [user]);

  const onSubmit = async () => {
    try {
      if (!dataAgreement.acceptedAgreementId) {
        await fetchHelper.post("/patientmanagement/rest/user-agreements/save-accepted-agreements", {
          acceptedAgreements: [dataAgreement.agreementId],
        });
      } else {
        await fetchHelper.put("/patientmanagement/rest/user-agreements/update-accepted-agreements", {
          userAgreements: [dataAgreement.acceptedAgreementId],
        });
      }
      setDataAgreement({});
    } catch (error) {
      handleErrors(error);
    } finally {
      localStorage.removeItem("showUserAgreements");
    }
  };

  const onSkip = async () => {
    localStorage.removeItem("showUserAgreements");
    setDataAgreement({});
  };

  const handleErrors = ({ validationErrors }) => {
    validationErrors &&
      validationErrors.forEach((err) => {
        addToast(err.errorMessage, {
          appearance: "error",
          autoDismiss: false,
        });
      });
  };

  const showUserAgreementsModal = () => {
    return Boolean(Object.keys(dataAgreement).length && localStorage.getItem("showUserAgreements"));
  };

  return showUserAgreementsModal() ? (
    <div className="modal override-row popup show" id="modalAgreements">
      <div className="modalContent">
        <div className="grpHdr">
          <h2>{dataAgreement.agreementHeader}</h2>
        </div>
        <p>Please accept the agreement to access the portal</p>
        <p>{dataAgreement.agreementText}</p>
        {!dataAgreement.isForced ? (
          <p className="remaining-days">Remaining days: {dataAgreement.numberOfDaysRemainingToAck}</p>
        ) : null}
        <div className="row rowStretch noMargin">
          <button className="btn btn-sm btn-teal" onClick={onSubmit}>
            Accept
          </button>
          {!dataAgreement.isForced ? (
            <button className="btn btn-sm btn-teal" onClick={onSkip}>
              Skip
            </button>
          ) : null}
          {dataAgreement.isForced ? (
            <button className="btn btn-cancel" style={{ height: "auto" }} onClick={logout}>
              Log Out
            </button>
          ) : null}
        </div>
      </div>
    </div>
  ) : null;
};

export default ModalAgreements;
